var React = require('react');

function Icons8Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.5 5A2.52 2.52 0 0 0 5 7.5v17A2.52 2.52 0 0 0 7.5 27h17a2.52 2.52 0 0 0 2.5-2.5v-17A2.52 2.52 0 0 0 24.5 5zm0 2h17a.49.49 0 0 1 .5.5v17a.49.49 0 0 1-.5.5h-17a.49.49 0 0 1-.5-.5v-17a.49.49 0 0 1 .5-.5zm2.938 1.719a1.72 1.72 0 0 0-1.719 1.719 1.72 1.72 0 0 0 1.719 1.719 1.72 1.72 0 0 0 1.719-1.719 1.72 1.72 0 0 0-1.719-1.719zm9.031 4.563c-1.434 0-2.387.785-2.781 1.531h-.062V13.5h-2.812V23h2.938v-4.687c0-1.238.246-2.437 1.781-2.437 1.512 0 1.531 1.398 1.531 2.5V23H23v-5.219c0-2.555-.543-4.5-3.531-4.5zM9 13.5V23h2.969v-9.5z"}));
}

Icons8Linkedin.defaultProps = {"viewBox":"0 0 32 32","fill":"#000000","xmlnsV":"https://vecta.io/nano"};

module.exports = Icons8Linkedin;

Icons8Linkedin.default = Icons8Linkedin;
